import { preloadImage } from '../hooks/mediaPreload';
import { withAlternateArtDisplayOrder } from './alternateArtDisplay.js';
import { getOrderCardImageSrc } from './orderCardImageSrc.js';

/**
 * Warm the browser image cache for a batch of order card portraits (menus / strategy grid).
 * Safe to call fire-and-forget; duplicate paths share preloadImage promises.
 * @param {Array<{ id?: unknown, image?: unknown, useAlternateArt?: unknown }>} orders
 * @returns {Promise<PromiseSettledResult<unknown>[]>}
 */
export function preloadOrderCardImages(orders) {
  if (!Array.isArray(orders) || orders.length === 0) {
    return Promise.resolve([]);
  }

  const uniqueSrcs = new Set();
  for (const order of orders) {
    if (!order) {
      continue;
    }
    uniqueSrcs.add(getOrderCardImageSrc(withAlternateArtDisplayOrder(order)));
  }

  return Promise.allSettled([...uniqueSrcs].map((src) => preloadImage(src)));
}
